import { API_CONFIG, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false" && UAT === "false";
const LOCAL_PORT = "7005";

export const CRM_APIs = {
  manageCrmLeadProfile: async (args = {}) => {
    let apiUrl = "/cu/v1/D66W379BYS9SAL52";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // getLeadProfiles: async (args = {}) => {
  //   let apiUrl = "/ac/v1/149Z7769V62163UT";
  //   if (local) {
  //     apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
  //   }
  //   const response = await COMMON_JS.callApi(
  //     apiUrl,
  //     API_CONFIG.METHODS.POST,
  //     args,
  //     false,
  //     local
  //   );
  //   return response;
  // },

  getCrmDocuments: async (args = {}) => {
    let apiUrl = "/cu/v1/R4W8OQMOLYH02ACT";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCrmLeadDocument: async (args = {}) => {
    let apiUrl = "/cu/v1/6DX11JJXE7RM0NSB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getCrmLeadDocuments: async (args = {}) => {
    let apiUrl = "/cu/v1/923G194QZUQQRC9N";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getCrmApprovals: async (args = {}) => {
    let apiUrl = "/cu/v1/48GR8BYQUY4SOU02";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getCrmLeadApprovals: async (args = {}) => {
    let apiUrl = "/cu/v1/UP9O0S3J9ZSEYHVI";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCrmLeadApproval: async (args = {}) => {
    let apiUrl = "/cu/v1/5SLCS9BCN0BGUG2R";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // getCrmLeadInterviewQuestion: async (args = {}) => {
  //   let resObj: any = {};

  //   resObj = {
  //     status: 200,
  //     response: {
  //       records: [
  // {
  //   id:"1",
  //   questionId:"question number 1",
  //   question:"this is question 1"
  // },
  // {
  //   id:"2",
  //   questionId:"question number 2",
  //   question:"this is question 2"
  // },  {
  //   id:"3",
  //   questionId:"question number 3",
  //   question:"this is question 3"
  // },
  // {
  //   id:"4",
  //   questionId:"question number 4",
  //   question:"this is question 4"
  // }
  //       ],
  //     },
  //   };
  //   return resObj;

  // },

  getCrmLeadInterviews: async (args = {}) => {
    let apiUrl = "/cu/v1/O1TJ3YZ556IX8QVI";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCrmLeadInterview: async (args = {}) => {
    let apiUrl = "/cu/v1/FLIJRM7U62KACFM3";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getLeadProfileImport: async (args = {}) => {
    let resObj: any = {};

    resObj = {
      status: 200,
      response: {
        records: [
          {
            id: "1",
            file: "/static/storevisit/2023/10/231027Oct101698393602317655_54.pdf",
            date: "2023-10-10",
            executive: "dev123",
          },
          {
            id: "2",
            file: "/static/storevisit/2023/10/231027Oct101698393654876461_54.png",
            date: "2023-10-20",
            executive: "dev123",
          },
        ],
      },
    };
    return resObj;
  },
  getTurnOverValidator: async (args = {}) => {
    let resObj: any = {};

    resObj = {
      status: 200,
      response: {
        records: [
          {
            id: "1",
            limit: "1000000",
            message: "Please Check Entered Data",
          },
        ],
      },
    };
    return resObj;
  },

  manageCrmRemarks: async (args = {}) => {
    let apiUrl = "/cu/v1/VOIA9QZ56BFZB4VB";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  
  getCrmRemarks: async (args = {}) => {
    let apiUrl = "/cu/v1/KW7K5FSB6P2Y5HU6";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  manageCrmApprove: async (args = {}) => {
    let apiUrl = "/cu/v1/4WB3VEDJEF4D6UR2";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
};
